import { createSlice } from "@reduxjs/toolkit";
import { IResponseWithPagination } from "src/@types/api";
import { IDeal } from "src/@types/deals";
import { DEALS_SLICE_NAME } from "./actions";
import { getDealsReducer } from "./reducers";

export interface DealsState {
  isLoading: boolean,
  data: IResponseWithPagination<IDeal>;
}

const initialState: DealsState = {
  isLoading: false,
  data: null,
};

export const { reducer: deals } = createSlice({
  name: DEALS_SLICE_NAME,
  initialState,
  reducers: {},
  extraReducers(builder) {
    getDealsReducer(builder);
  },
});
